import { Button, ButtonColors } from '@chiroup/components/Button';
import { OpenClosedStates } from '@chiroup/core/enums/OpenClosedStates.enum';
import React, { useState } from 'react';
import { useAdminPermissions } from '../../hooks/useAdminPermissions';
import UserCreateModal from './UserCreateModal';

type Props = {
  onCreate: () => void;
};

const UserCreate: React.FC<Props> = ({ onCreate }) => {
  const [state, setState] = useState<OpenClosedStates>(OpenClosedStates.Closed);
  const { hasPermission } = useAdminPermissions();

  const open = () => {
    setState(OpenClosedStates.Open);
  };

  const close = () => {
    setState(OpenClosedStates.Closed);
  };

  return (
    <>
      <UserCreateModal
        state={state}
        close={close}
        onCreate={onCreate}
        // lastName={lastName}
      />
      {hasPermission('users.create') && (
        <Button
          text="Add"
          color={ButtonColors.plainWithBorder}
          className="cursor-pointer"
          onClick={open}
        />
      )}
    </>
  );
};

export default UserCreate;
